/** 容器实例：镜像 containerDeployConfig 写入的服务列表 path */
export const CI_SERVICES_PATH = 'resource.network.services';

/** 容器实例：containerDeployConfig 写入的 system 子树前缀 */
export const CI_DEPLOY_SYSTEM_FIELD = 'system';

/** 镜像 containerDeployConfig.instanceScheduling，供 compute linkage 读取最小资源约束 */
export const CONTAINER_DEPLOY_INSTANCE_SCHEDULING_FIELD = '_containerDeployInstanceScheduling';

/** 镜像选中标识；linkage 仅监听此字段，避免编辑 command/startupArgs 时重复清场 */
export const CI_BASIC_IMAGE_KEY_FIELD = 'basic.image.key';
